module.exports = __webpack_public_path__ + "img/process-done-white.f0b5cd72.svg";